export const jobPostingReview = {
  header: 'Review Job Post',
  position: {
    header: 'Position',
    skillsAndRequirements: 'Skills & Requirements',
    badges: 'Badges',
    tasks: 'Tasks'
  },
  footer: {
    postJob: 'Post job',
  },
  invalidCategoryModal: {
    title: 'Select this job\'s position category',
    subtitle: 'Please choose the category that best describes the position.',
    inputLabel: 'Position Category',
    submitLabel: 'Save and post job',
  },
  schedule: {
    header: 'Schedule',
    viewInCalendar: 'View in calendar',
    dateRange: '%startDate% - %endDate%',
    workdays: '%workdays% workdays',
    timeRange: '%startTime% - %endTime%',
    unpaidBreakMinutes: '%unpaidBreakMinutes% min break',
    calendar: {
      header: 'Job Schedule',
      close: 'Got it'
    },
    customizedTimeRange: '%date% is %startTime% - %endTime%',
    rest: 'Rest'
  },
  workers: {
    header: 'Workers',
    workersPerDay: 'Workers per day',
    sameWorkers: 'Same workers for all workdays?',
    openWorkerPool: 'Lower pool?',
    remainingDays: 'Remaining Days',
    preferredWonoloersCount: '(%preferredWonoloersCount% preferred)'
  },
  location: {
    header: 'Location',
    venue: 'Location',
    checkInRadius: 'Check-In Radius',
    travelTips: 'Travel Tips & Arrival Instructions'
  },
};
